/* ========================================
   COOKVIVO - Shopify Theme JavaScript
   Adapted from static site for Shopify Liquid
   ======================================== */

document.addEventListener('DOMContentLoaded', function() {
  'use strict';

  // === Header Scroll Effect ===
  const header = document.querySelector('.header');
  function handleScroll() {
    if (header) {
      if (window.scrollY > 60) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }
  }
  window.addEventListener('scroll', handleScroll, { passive: true });

  // === Mobile Menu ===
  const mobileToggle = document.querySelector('.mobile-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileMenuOverlay = document.querySelector('.mobile-menu-overlay');
  const mobileMenuClose = document.querySelector('.mobile-menu-close');

  function openMobileMenu() {
    if (mobileToggle) mobileToggle.classList.add('active');
    if (mobileMenu) mobileMenu.classList.add('open');
    if (mobileMenuOverlay) mobileMenuOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (mobileToggle) mobileToggle.classList.remove('active');
    if (mobileMenu) mobileMenu.classList.remove('open');
    if (mobileMenuOverlay) mobileMenuOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (mobileToggle) mobileToggle.addEventListener('click', openMobileMenu);
  if (mobileMenuOverlay) mobileMenuOverlay.addEventListener('click', closeMobileMenu);
  if (mobileMenuClose) mobileMenuClose.addEventListener('click', closeMobileMenu);

  // === Cart Drawer (Shopify AJAX API) ===
  const cartTriggers = document.querySelectorAll('[data-cart-trigger]');
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-overlay');
  const cartClose = document.querySelector('.cart-close');
  const cartCountEls = document.querySelectorAll('.cart-count');
  const cartBody = document.querySelector('.cart-body');
  const cartSubtotal = document.querySelector('.subtotal-amount');
  const cartEmpty = document.querySelector('.cart-empty');
  const cartFooter = document.querySelector('.cart-drawer .cart-footer');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartTriggers.forEach(function(trigger) {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      openCart();
    });
  });

  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);

  // Shopify AJAX Cart API
  function fetchCart() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    }).then(function(r) { return r.json(); });
  }

  function addItem(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then(function(r) { return r.json(); });
  }

  function changeItem(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function(r) { return r.json(); });
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return '$' + amount;
  }

  function updateCartCount(count) {
    cartCountEls.forEach(function(el) {
      el.textContent = count;
      if (count > 0) {
        el.style.display = 'inline-flex';
      } else {
        el.style.display = 'none';
      }
    });
  }

  function refreshCart() {
    fetchCart().then(function(cart) {
      updateCartCount(cart.item_count);

      if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);

      if (cartBody) {
        // Clear existing items
        var existing = cartBody.querySelectorAll('.cart-item');
        existing.forEach(function(el) { el.remove(); });

        if (cart.item_count === 0) {
          if (cartEmpty) cartEmpty.style.display = 'block';
          if (cartFooter) cartFooter.style.display = 'none';
        } else {
          if (cartEmpty) cartEmpty.style.display = 'none';
          if (cartFooter) cartFooter.style.display = 'block';

          // Free shipping threshold
          var threshold = 9900; // $99 default
          if (cartFooter && cartFooter.dataset.threshold) {
            threshold = parseInt(cartFooter.dataset.threshold);
          }
          var remaining = threshold - cart.total_price;
          var progressEl = cartFooter ? cartFooter.querySelector('.free-shipping-progress') : null;
          if (!progressEl && cartFooter) {
            progressEl = document.createElement('p');
            progressEl.className = 'free-shipping-progress';
            progressEl.style.cssText = 'font-size:0.8rem;color:var(--color-text-secondary);margin:8px 0 0;';
            cartFooter.insertBefore(progressEl, cartFooter.firstChild);
          }
          if (progressEl) {
            if (remaining > 0) {
              progressEl.innerHTML = 'You\'re ' + formatMoney(remaining) + ' away from <strong>FREE shipping!</strong>';
              progressEl.style.display = 'block';
            } else {
              progressEl.innerHTML = '<strong>You\'ve unlocked FREE shipping!</strong> 🎉';
              progressEl.style.display = 'block';
            }
          }

          // Render items
          cart.items.forEach(function(item, index) {
            var el = document.createElement('div');
            el.className = 'cart-item';
            var imgSrc = item.image ? item.image.replace('.jpg', '_120x.jpg').replace('.png', '_120x.png') : '';
            // Use Shopify image URL sizing
            if (item.image) {
              imgSrc = item.image;
              if (imgSrc.indexOf('?') === -1) {
                imgSrc += '?width=120&height=120&crop=center';
              }
            }
            el.innerHTML = 
              '<div class="cart-item-img">' +
                (imgSrc ? '<img src="' + imgSrc + '" alt="' + item.title + '" style="width:100%;height:100%;object-fit:cover;">' : '<span style="font-size:1.5rem;">🍳</span>') +
              '</div>' +
              '<div class="cart-item-info">' +
                '<div class="cart-item-name">' + item.product_title + '</div>' +
                (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-item-variant">' + item.variant_title + '</div>' : '') +
                '<div class="cart-item-price">' + formatMoney(item.final_line_price) + '</div>' +
                '<div class="cart-item-qty">' +
                  '<button class="qty-btn" data-line="' + (index + 1) + '" data-action="dec">−</button>' +
                  '<span class="qty-value">' + item.quantity + '</span>' +
                  '<button class="qty-btn" data-line="' + (index + 1) + '" data-action="inc">+</button>' +
                  '<a href="' + (item.url_to_remove || '/cart') + '" class="cart-item-remove" data-line="' + (index + 1) + '">Remove</a>' +
                '</div>' +
              '</div>';
            cartBody.appendChild(el);
          });

          // Bind qty buttons
          cartBody.querySelectorAll('.qty-btn').forEach(function(btn) {
            btn.addEventListener('click', function() {
              var line = parseInt(this.dataset.line);
              var action = this.dataset.action;
              var qtyEl = this.parentElement.querySelector('.qty-value');
              var currentQty = parseInt(qtyEl.textContent);
              var newQty = action === 'inc' ? currentQty + 1 : Math.max(0, currentQty - 1);
              changeItem(line, newQty).then(function(cart) {
                updateCartCount(cart.item_count);
                if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
                if (newQty === 0) {
                  refreshCart();
                } else {
                  qtyEl.textContent = newQty;
                }
              });
            });
          });

          // Bind remove links
          cartBody.querySelectorAll('.cart-item-remove').forEach(function(link) {
            link.addEventListener('click', function(e) {
              e.preventDefault();
              var line = parseInt(this.dataset.line);
              changeItem(line, 0).then(function() {
                refreshCart();
              });
            });
          });
        }
      }
    });
  }

  // Expose globally for product pages
  window.COOKVIVO = {
    addToCart: function(variantId, quantity, callback) {
      addItem(variantId, quantity).then(function() {
        updateCartCountFromServer();
        showToast('Added to cart!');
        if (callback) callback();
        openCart();
      }).catch(function() {
        showToast('Something went wrong. Please try again.');
      });
    },
    refreshCart: refreshCart,
    openCart: openCart,
    closeCart: closeCart
  };

  function updateCartCountFromServer() {
    fetchCart().then(function(cart) {
      updateCartCount(cart.item_count);
    });
  }

  // Initialize cart count on page load
  updateCartCountFromServer();

  // === Server-rendered cart drawer item controls (override link navigation) ===
  document.querySelectorAll('[data-cart-decrease], [data-cart-increase]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var line = parseInt(this.dataset.cartDecrease || this.dataset.cartIncrease);
      var isIncrease = this.hasAttribute('data-cart-increase');
      var qtyEl = this.parentElement.querySelector('.qty-value');
      var currentQty = parseInt(qtyEl ? qtyEl.textContent : 1);
      var newQty = isIncrease ? currentQty + 1 : Math.max(0, currentQty - 1);
      changeItem(line, newQty).then(function() {
        refreshCart();
      });
    });
  });
  document.querySelectorAll('[data-cart-remove]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      var line = parseInt(this.dataset.cartRemove);
      changeItem(line, 0).then(function() {
        refreshCart();
      });
    });
  });

  // === Add to Cart (AJAX) — for product cards and product page ===
  document.querySelectorAll('[data-add-to-cart]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = this.dataset.variantId || this.dataset.productId;
      var quantity = parseInt(this.dataset.quantity) || 1;
      var productName = this.dataset.productName || 'Item';
      if (variantId) {
        addItem(variantId, quantity).then(function() {
          updateCartCountFromServer();
          showToast(productName + ' added to cart');
          openCart();
        }).catch(function() {
          showToast('Unable to add item. Please try again.');
        });
      }
    });
  });

  // Also support forms with data-cart-form
  document.querySelectorAll('form[data-cart-form]').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var formData = new FormData(form);
      var variantId = formData.get('id');
      var quantity = formData.get('quantity') || 1;
      if (variantId) {
        addItem(variantId, quantity).then(function() {
          updateCartCountFromServer();
          showToast('Added to cart!');
          openCart();
        }).catch(function() {
          showToast('Unable to add item. Please try again.');
        });
      }
    });
  });

  // === Toast Notification ===
  function showToast(message) {
    var toast = document.querySelector('.toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'toast';
      toast.innerHTML = 
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
          '<path d="M9 12l2 2 4-4"/>' +
          '<circle cx="12" cy="12" r="10"/>' +
        '</svg>' +
        '<span class="toast-message"></span>';
      document.body.appendChild(toast);
    }
    toast.querySelector('.toast-message').textContent = message;
    toast.classList.add('show');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function() {
      toast.classList.remove('show');
    }, 3000);
  }

  // === FAQ Accordion ===
  document.querySelectorAll('.faq-question').forEach(function(question) {
    question.addEventListener('click', function() {
      var item = this.closest('.faq-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function(i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  // === Scroll Animations (Intersection Observer) ===
  var observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -80px 0px'
  };

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, observerOptions);

  document.querySelectorAll('.fade-up, .fade-in').forEach(function(el) {
    observer.observe(el);
  });

  // === Newsletter Form ===
  var newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function(e) {
      // Let Shopify handle the form submission, but show feedback
      var input = this.querySelector('.newsletter-input');
      var email = input ? input.value.trim() : '';
      if (!email || !email.includes('@')) {
        e.preventDefault();
        showToast('Please enter a valid email address.');
      } else {
        showToast('Thanks for subscribing! Check your inbox.');
      }
    });
  }

  // === Product Card Quick Add — Shopify handles navigation natively ===
  document.querySelectorAll('.product-card').forEach(function(card) {
    card.style.cursor = 'pointer';
    // Make card clickable to product page (Shopify product.url)
    card.addEventListener('click', function(e) {
      var quickAdd = this.querySelector('[data-add-to-cart]');
      if (quickAdd && quickAdd.contains(e.target)) return;
      var link = this.querySelector('a[href*="/products/"]');
      if (link) {
        window.location.href = link.getAttribute('href');
      }
    });
  });

  // === Recipe Card Click ===
  document.querySelectorAll('.recipe-card').forEach(function(card) {
    card.addEventListener('click', function() {
      var recipeName = this.querySelector('.recipe-title') ? this.querySelector('.recipe-title').textContent : 'Recipe';
      showToast('Opening recipe: ' + recipeName);
    });
  });

  // === Smooth Scroll for Anchor Links ===
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var href = this.getAttribute('href');
      if (href === '#' || href === '') return;
      var target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        var offset = 120;
        var targetPosition = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
      }
    });
  });

  // === Parallax Hero (subtle) ===
  var heroBg = document.querySelector('.hero-bg-img');
  if (heroBg) {
    window.addEventListener('scroll', function() {
      var scrolled = window.scrollY;
      if (scrolled < window.innerHeight) {
        heroBg.style.transform = 'translateY(' + (scrolled * 0.3) + 'px) scale(' + (1 + scrolled * 0.0003) + ')';
      }
    }, { passive: true });
  }

  // === Counter Animation for Stats ===
  function animateCounter(el, target, duration) {
    duration = duration || 2000;
    var startTime = performance.now();
    function update(currentTime) {
      var elapsed = currentTime - startTime;
      var progress = Math.min(elapsed / duration, 1);
      var current = Math.floor(target * progress);
      el.textContent = current.toLocaleString();
      if (progress < 1) requestAnimationFrame(update);
    }
    requestAnimationFrame(update);
  }

  var counterObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var target = parseInt(entry.target.dataset.count);
        if (target) animateCounter(entry.target, target);
        counterObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  document.querySelectorAll('[data-count]').forEach(function(el) { counterObserver.observe(el); });

  // === Close drawers on Escape ===
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeCart();
      closeMobileMenu();
      // Close chat widget
      var chatPanel = document.getElementById('chat-panel');
      if (chatPanel) chatPanel.classList.remove('open');
    }
  });

  // === Search Button ===
  var searchBtn = document.getElementById('header-search-btn');
  if (searchBtn) {
    searchBtn.addEventListener('click', function() {
      window.location.href = '/search';
    });
  }

  // === Product Page: Gallery Thumbnail Switching ===
  document.querySelectorAll('.gallery-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var mainImg = document.querySelector('.gallery-main img');
      var newSrc = this.dataset.full || (this.querySelector('img') ? this.querySelector('img').src : '');
      if (mainImg && newSrc) {
        mainImg.src = newSrc;
      }
      document.querySelectorAll('.gallery-thumb').forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  // === Product Page: Variant Selection ===
  document.querySelectorAll('[data-variant-id]').forEach(function(btn) {
    if (btn.tagName === 'BUTTON' || btn.classList.contains('variant-option')) {
      btn.addEventListener('click', function() {
        var variantId = this.dataset.variantId;
        var variantPrice = this.dataset.variantPrice;
        var hiddenInput = document.querySelector('input[name="id"]');
        var priceEl = document.querySelector('.product-price');
        var compareEl = document.querySelector('.product-compare-price');

        if (hiddenInput) hiddenInput.value = variantId;
        if (priceEl && variantPrice) priceEl.textContent = variantPrice;

        // Update active state
        document.querySelectorAll('[data-variant-id]').forEach(function(b) {
          if (b.tagName === 'BUTTON' || b.classList.contains('variant-option')) {
            b.classList.remove('active');
          }
        });
        this.classList.add('active');

        // Update add-to-cart button
        var addBtn = document.querySelector('[data-add-to-cart]');
        if (addBtn) {
          addBtn.dataset.variantId = variantId;
        }
      });
    }
  });

  // === Product Page: Quantity Controls ===
  document.querySelectorAll('.qty-decrease').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = document.querySelector('.quantity-input');
      if (input) {
        var val = parseInt(input.value) || 1;
        if (val > 1) input.value = val - 1;
        var addBtn = document.querySelector('[data-add-to-cart]');
        if (addBtn) addBtn.dataset.quantity = input.value;
      }
    });
  });

  document.querySelectorAll('.qty-increase').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = document.querySelector('.quantity-input');
      if (input) {
        var val = parseInt(input.value) || 1;
        input.value = val + 1;
        var addBtn = document.querySelector('[data-add-to-cart]');
        if (addBtn) addBtn.dataset.quantity = input.value;
      }
    });
  });

  // === Product Page: Tab Switching ===
  document.querySelectorAll('.tab-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var target = this.dataset.tab;
      document.querySelectorAll('.tab-btn').forEach(function(b) { b.classList.remove('active'); });
      document.querySelectorAll('.tab-panel').forEach(function(p) { p.classList.remove('active'); });
      this.classList.add('active');
      var panel = document.getElementById(target);
      if (panel) panel.classList.add('active');
    });
  });

  // === Collection Page: Sort Dropdown ===
  var sortSelect = document.getElementById('sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var val = this.value;
      if (val) {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', val);
        window.location.href = url.toString();
      }
    });
  }

  // === Collection Page: Price Filter (client-side) ===
  var priceFilterForm = document.getElementById('price-filter');
  if (priceFilterForm) {
    priceFilterForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var min = parseFloat(this.querySelector('[name="min_price"]').value) || 0;
      var max = parseFloat(this.querySelector('[name="max_price"]').value) || Infinity;
      var cards = document.querySelectorAll('.product-card');
      cards.forEach(function(card) {
        var priceText = card.querySelector('.product-card-price');
        if (priceText) {
          var price = parseFloat(priceText.textContent.replace(/[^0-9.]/g, ''));
          if (price >= min && price <= max) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        }
      });
    });
  }

  // === Cart Page: Quantity Update ===
  var cartPageForm = document.querySelector('form[action*="/cart"]');
  if (cartPageForm && cartPageForm.dataset.ajax !== 'true') {
    // Let Shopify's native cart form handle updates
    // but add AJAX for better UX
    cartPageForm.addEventListener('change', function(e) {
      if (e.target.name === 'updates[]') {
        this.submit();
      }
    });
  }

  // === Initialize Chat Widget ===
  initChatWidget();
});

// ============================================================
// CHAT WIDGET LOGIC (unchanged from static version)
// ============================================================
function initChatWidget() {
  var STORAGE_KEY = 'cookvivo_chat_messages';
  var panel = document.getElementById('chat-panel');
  var toggle = document.getElementById('chat-toggle');
  var closeBtn = document.getElementById('chat-close');
  var body = document.getElementById('chat-body');
  var input = document.getElementById('chat-input');
  var sendBtn = document.getElementById('chat-send');
  var quickReplies = document.getElementById('chat-quick-replies');
  var badge = document.querySelector('.chat-unread-badge');

  if (!panel || !toggle) return;

  var isOpen = false;
  var unreadCount = 0;

  var quickQuestions = [
    { label: 'Shipping Info', text: 'What are your shipping options and delivery times?', key: 'shipping' },
    { label: 'Return Policy', text: 'What is your return policy?', key: 'returns' },
    { label: 'Warranty', text: 'How does the lifetime warranty work?', key: 'warranty' },
    { label: 'Product Care', text: 'How do I clean and care for my cookware?', key: 'care' },
    { label: 'Talk to Human', text: 'I need to speak with a human agent.', key: 'human' }
  ];

  var autoReplies = {
    shipping: "We offer FREE standard shipping on all orders over $99 (3-5 business days). Express shipping (1-2 days) is available for $14.99. International shipping is available to 40+ countries. Orders placed before 2 PM EST ship same day! 📦",
    returns: "We offer a 30-day risk-free trial on all cookware. If you're not 100% satisfied, return it for a full refund — no questions asked. Simply email returns@cookvivo.com with your order number and we'll send a prepaid return label. 💚",
    warranty: "Every COOKVIVO product comes with a **Lifetime Warranty** covering manufacturing defects. Just register your product within 30 days of purchase. Claims are processed within 5 business days. 🛡️",
    care: "Here's how to care for your cookware:\n\n• **First use:** Wash with warm soapy water, dry thoroughly\n• **Cooking:** Use low to medium heat for best results\n• **Cleaning:** Dishwasher safe, but hand-washing extends coating life\n• **Storage:** Stack with protective felt pads between pieces\n\nSee our full guide on the Proper Use & Care page! 🔧",
    human: "I'm connecting you with a team member. Please leave your name, email, and a brief message — we'll respond within 4 hours during business hours (9 AM–6 PM EST, Mon–Fri). You can also reach us at support@cookvivo.com."
  };

  function togglePanel(force) {
    if (typeof force === 'boolean') {
      isOpen = force;
    } else {
      isOpen = !isOpen;
    }
    if (isOpen) {
      panel.classList.add('open');
      unreadCount = 0;
      if (badge) badge.classList.remove('show');
      setTimeout(function() {
        if (body) body.scrollTop = body.scrollHeight;
        if (input) input.focus();
      }, 100);
    } else {
      panel.classList.remove('open');
    }
  }

  function saveMessages(msgs) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(msgs));
    } catch(e) {}
  }

  function loadMessages() {
    try {
      var saved = sessionStorage.getItem(STORAGE_KEY);
      if (saved) return JSON.parse(saved);
    } catch(e) {}
    return null;
  }

  function formatTime() {
    var now = new Date();
    var h = now.getHours();
    var m = now.getMinutes();
    var ampm = h >= 12 ? 'PM' : 'AM';
    h = h % 12 || 12;
    m = m < 10 ? '0' + m : m;
    return h + ':' + m + ' ' + ampm;
  }

  function addMessage(text, type, agentName) {
    var msgDiv = document.createElement('div');
    msgDiv.className = 'chat-msg ' + (type === 'user' ? 'user' : 'agent');
    if (agentName && type === 'agent') {
      var nameDiv = document.createElement('div');
      nameDiv.className = 'agent-name';
      nameDiv.textContent = agentName;
      msgDiv.appendChild(nameDiv);
    }
    var textDiv = document.createElement('div');
    var html = text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      .replace(/\n/g, '<br>');
    textDiv.innerHTML = html;
    msgDiv.appendChild(textDiv);
    if (body) {
      body.appendChild(msgDiv);
      body.scrollTop = body.scrollHeight;
    }
    var msgs = loadMessages() || [];
    msgs.push({ text: text, type: type, agentName: agentName, time: formatTime() });
    saveMessages(msgs);
  }

  function showTyping() {
    var typing = document.createElement('div');
    typing.className = 'chat-typing';
    typing.id = 'chat-typing-indicator';
    typing.innerHTML = '<span></span><span></span><span></span>';
    if (body) {
      body.appendChild(typing);
      body.scrollTop = body.scrollHeight;
    }
  }

  function hideTyping() {
    var typing = document.getElementById('chat-typing-indicator');
    if (typing) typing.remove();
  }

  function sendUserMessage(text) {
    if (!text || !text.trim()) return;
    addMessage(text.trim(), 'user');
    if (input) input.value = '';
    if (sendBtn) sendBtn.disabled = true;
    if (quickReplies) quickReplies.style.display = 'none';

    setTimeout(showTyping, 300);

    setTimeout(function() {
      hideTyping();
      var lowerText = text.toLowerCase();
      var matched = null;
      var matchedKey = null;

      for (var i = 0; i < quickQuestions.length; i++) {
        var q = quickQuestions[i];
        if (lowerText.indexOf(q.key) >= 0 || lowerText.indexOf(q.label.toLowerCase().split(' ')[0]) >= 0) {
          matched = autoReplies[q.key];
          matchedKey = q.key;
          break;
        }
      }

      if (!matched) {
        if (lowerText.indexOf('ship') >= 0 || lowerText.indexOf('deliver') >= 0) {
          matched = autoReplies.shipping;
        } else if (lowerText.indexOf('return') >= 0 || lowerText.indexOf('refund') >= 0) {
          matched = autoReplies.returns;
        } else if (lowerText.indexOf('warranty') >= 0 || lowerText.indexOf('guarantee') >= 0) {
          matched = autoReplies.warranty;
        } else if (lowerText.indexOf('clean') >= 0 || lowerText.indexOf('care') >= 0) {
          matched = autoReplies.care;
        } else if (lowerText.indexOf('human') >= 0 || lowerText.indexOf('agent') >= 0 || lowerText.indexOf('contact') >= 0) {
          matched = autoReplies.human;
        } else if (lowerText.indexOf('price') >= 0 || lowerText.indexOf('cost') >= 0) {
          matched = "Our cookware ranges from $49 to $399. Check our collection page for current pricing and sale discounts! 🔥";
        } else if (lowerText.indexOf('titanium') >= 0) {
          matched = "Our cookware uses aerospace-grade 316Ti titanium. 100% PFAS-free and PFOA-free! 🔬";
        } else if (lowerText.indexOf('hello') >= 0 || lowerText.indexOf('hi') >= 0 || lowerText.indexOf('hey') >= 0) {
          matched = "Hello! Welcome to COOKVIVO! 👋 How can I help you today?";
        } else if (lowerText.indexOf('thank') >= 0) {
          matched = "You're very welcome! 😊 Happy cooking with COOKVIVO! 🍳";
        } else {
          matched = "Thanks for your message! Tap the quick replies below, or leave your email and message and our team will respond within 4 hours. Email: support@cookvivo.com 💬";
        }
      }

      addMessage(matched, 'agent', 'COOKVIVO Bot');

      if (matchedKey === 'human' || lowerText.indexOf('human') >= 0 || lowerText.indexOf('email') >= 0 || lowerText.indexOf('contact') >= 0) {
        setTimeout(function() {
          addMessage("Want to leave a message? Fill out the form below! 📧", 'agent', 'COOKVIVO Bot');
          showOfflineForm();
        }, 500);
      }

      if (sendBtn) sendBtn.disabled = false;

      if (!isOpen) {
        unreadCount++;
        if (badge) {
          badge.textContent = unreadCount;
          badge.classList.add('show');
        }
      }
    }, 800 + Math.random() * 500);
  }

  function showOfflineForm() {
    if (document.getElementById('chat-offline-form')) return;
    var formHtml = '<div class="chat-offline-form" id="chat-offline-form">' +
      '<input type="text" id="chat-offline-name" placeholder="Your Name" />' +
      '<input type="email" id="chat-offline-email" placeholder="Your Email" />' +
      '<textarea id="chat-offline-message" placeholder="How can we help you?"></textarea>' +
      '<button class="btn btn-primary btn-sm" id="chat-offline-submit" style="width:100%;">Send Message</button>' +
      '</div>';
    var formDiv = document.createElement('div');
    formDiv.innerHTML = formHtml;
    if (body) {
      body.appendChild(formDiv);
      body.scrollTop = body.scrollHeight;
    }
    var submitBtn = document.getElementById('chat-offline-submit');
    if (submitBtn) {
      submitBtn.addEventListener('click', function() {
        var name = document.getElementById('chat-offline-name').value.trim();
        var email = document.getElementById('chat-offline-email').value.trim();
        var msg = document.getElementById('chat-offline-message').value.trim();
        if (!name || !email || !msg) {
          alert('Please fill in all fields.');
          return;
        }
        var form = document.getElementById('chat-offline-form');
        if (form) {
          form.innerHTML = '<div class="chat-offline-success">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>' +
            '<p>Message sent! ✅</p>' +
            '<p style="font-size:13px;color:#666;margin-top:8px;">We\'ll reply to <strong>' + email + '</strong> within 4 hours.</p>' +
            '</div>';
        }
      });
    }
  }

  function initQuickReplies() {
    if (!quickReplies) return;
    quickReplies.innerHTML = '';
    for (var i = 0; i < quickQuestions.length; i++) {
      (function(q) {
        var btn = document.createElement('button');
        btn.className = 'chat-quick-reply';
        btn.textContent = q.label;
        btn.addEventListener('click', function() {
          sendUserMessage(q.text);
        });
        quickReplies.appendChild(btn);
      })(quickQuestions[i]);
    }
  }

  if (toggle) {
    toggle.addEventListener('click', function() { togglePanel(); });
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', function() { togglePanel(false); });
  }
  if (sendBtn) {
    sendBtn.addEventListener('click', function() {
      sendUserMessage(input ? input.value : '');
    });
  }
  if (input) {
    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        sendUserMessage(input.value);
      }
    });
  }

  var savedMsgs = loadMessages();
  if (savedMsgs && savedMsgs.length > 0) {
    for (var i = 0; i < savedMsgs.length; i++) {
      var m = savedMsgs[i];
      var msgDiv = document.createElement('div');
      msgDiv.className = 'chat-msg ' + (m.type === 'user' ? 'user' : 'agent');
      if (m.agentName) {
        var nameDiv = document.createElement('div');
        nameDiv.className = 'agent-name';
        nameDiv.textContent = m.agentName;
        msgDiv.appendChild(nameDiv);
      }
      var textDiv = document.createElement('div');
      var html = m.text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
        .replace(/\n/g, '<br>');
      textDiv.innerHTML = html;
      msgDiv.appendChild(textDiv);
      if (body) body.appendChild(msgDiv);
    }
    if (quickReplies) quickReplies.style.display = 'flex';
  } else {
    setTimeout(function() {
      addMessage("👋 Welcome to COOKVIVO! I'm your virtual assistant. How can I help you today? Tap a quick reply or type your question!", 'agent', 'COOKVIVO Bot');
    }, 500);
  }

  initQuickReplies();
}
